import { Card, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";
import { WorkplaceReviewCommentAuthorInfo } from "@src/appV2/redesign/Workplace/Review/Comment/CommentAuthorInfo";
import { ReviewContextPills } from "@src/appV2/redesign/Workplace/Review/Comment/ReviewContextPills";
import { parseISO } from "date-fns";
import { useState } from "react";

const REVIEW_TEXT_MAX_LENGTH = 300;
export const PEER_REVIEW_CARD_HEIGHT = "280px";

interface PeerReviewCardProps {
  comment: WorkplaceCommentType;
}

export function PeerReviewCard(props: PeerReviewCardProps) {
  const { comment } = props;
  const {
    text,
    workerInfo,
    shiftPeriod,
    shiftWorkerQualification,
    patientsPerNurse,
    reviewTag,
    createdAt,
  } = comment.attributes;

  const [isExpanded, setIsExpanded] = useState(false);
  const isLongText = text.length > REVIEW_TEXT_MAX_LENGTH;
  const displayText =
    isLongText && !isExpanded ? `${text.slice(0, REVIEW_TEXT_MAX_LENGTH)}...` : text;

  return (
    <Card
      variant="quaternary"
      sx={{
        borderRadius: 4,
        height: isExpanded ? "auto" : PEER_REVIEW_CARD_HEIGHT,
        overflow: "hidden",
        borderBottom: "1px solid",
        borderColor: (theme) => theme.palette.border?.primary,
      }}
    >
      <CardContent sx={{ padding: 7 }}>
        <Stack spacing={4}>
          <WorkplaceReviewCommentAuthorInfo
            useDelayedReviewLayout
            workerName={workerInfo.name}
            createdAt={parseISO(createdAt)}
            shiftWorkerQualification={shiftWorkerQualification}
          />
          <ReviewContextPills
            shiftPeriod={shiftPeriod}
            patientsPerNurse={patientsPerNurse}
            reviewTag={reviewTag}
          />
          <Text variant="body2">{displayText}</Text>
          {isLongText && (
            <TextButton
              sx={{ alignSelf: "flex-start" }}
              onClick={(event) => {
                event.stopPropagation();
                setIsExpanded((previous) => !previous);
              }}
            >
              {isExpanded ? "Read less" : "Read more"}
            </TextButton>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
